import React from "react";
import "./../InteractiveDemo.css";

export function InteractiveDemo() {
    return (
        <div className="interactive-demo">
            <header className="interactive-demo-header">
                <div className='nextgo-brand'>
                    <img
                        src={require("./../imgs/nextgo-logo.png")}
                        alt="Next Go Logo"
                        className="nextgo-logo"
                    />

                    <div>
                        Next<span>Go</span>
                    </div>
                </div>
            </header>

            <main className="interactive-demo-content">
                <div className="figma-container">
                    <iframe className="figma-iframe" src="https://embed.figma.com/proto/W5cUPDUu7uZwM3Tc8kTZwd/NextGo-Demo?node-id=11-12&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=11%3A12&embed-host=share" allowfullscreen></iframe>
                    {/* <iframe className="figma-iframe" src="https://embed.figma.com/proto/1OhpNxgoyBY6IcFgTdAENW/NextGo-Video-Demo?node-id=11-12&p=f&scaling=min-zoom&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=11%3A12&hotspot-hints=0&embed-host=share" allowfullscreen></iframe> */}
                </div>
            </main>
        </div>
    );
}